import React from "react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
import Form from 'react-bootstrap/Form';
import { Accordion } from "react-bootstrap";
import Col from 'react-bootstrap/Col';
import Nav from 'react-bootstrap/Nav';
import Row from 'react-bootstrap/Row';
import Tab from 'react-bootstrap/Tab';

function Modules() {

  const AccordionStyle = `
  
  .accordion-button{
    background-color: #F6F4F4 !important;
    padding: 1rem 1rem !important;
  }

  .tab-content>.active{
    background-color: #fff !important;
    border-radius: .3rem !important;
    padding: .8rem;
    height:30rem;
    overflow-y: scroll;
  }

  .accordion-item{
    background-color: #D9D9D9 !important;
    padding: .3rem 1rem .3rem .8rem;
  }

  .nav{
    background-color: #fff !important;
    border-radius: 0.8rem !important;
    padding: .3rem 0px;
    margin-bottom: 1rem;
    height: 30rem;
    overflow-y: scroll;
    display: block;
  }

  .nav-link {
  color: #000000 !important;
  }

  .nav-link:focus, .nav-link:hover{
  color: #005de8 !important;
  }
  
  .form-check-input{
    border: solid 1px #000;
  }

  `

  return (
    <>

      <style>{AccordionStyle}</style>

      <main className='' style={{ width: "100%" }}>

        <div className="row">
          <div className="col-12 mb-3">
            <Tab.Container id="left-tabs-example" defaultActiveKey="first">
              <Row>
                <Col md={6}>

                  <div className="d-flex justify-content-start mb-3">
                    <div className="d-flex justify-content-center" style={{ width: "8rem", padding: ".4rem .6rem" }}>
                      <span className="" style={{ fontSize: "20px" }}>Modules</span>
                    </div>
                  </div>

                  <Nav className="flex-column">
                    <Nav.Item>
                      <Nav.Link eventKey="1">
                        <div className=" rounded-2 p-3" style={{ background: '#F6F4F4', borderLeft: "solid 6px #005BE7", borderRadius: "none" }}>
                          <div className="d-flex flex-column gap-1">
                            <span className="">1. Patient Management Module</span>
                            <span style={{ color: "#959292", fontSize: "14px" }}>27/8/2020 | 5:00 pm</span>
                          </div>
                        </div>
                      </Nav.Link>
                    </Nav.Item>

                    <Nav.Item>
                      <Nav.Link eventKey="2">
                        <div className=" rounded-2 p-3" style={{ background: '#F6F4F4', borderLeft: "solid 6px #005BE7", borderRadius: "none" }}>

                          <div className="d-flex flex-column gap-1">
                            <span className="">2. Appointment & Consultation Module</span>
                            <span style={{ color: "#959292", fontSize: "14px" }}>27/8/2020 | 5:00 pm</span>
                          </div>
                        </div>
                      </Nav.Link>
                    </Nav.Item>

                    <Nav.Item>
                      <Nav.Link eventKey="3">
                        <div className=" rounded-2 p-3" style={{ background: '#F6F4F4', borderLeft: "solid 6px #005BE7", borderRadius: "none" }}>

                          <div className="d-flex flex-column gap-1">
                            <span className="">3. Payment & Finance Module </span>
                            <span style={{ color: "#959292", fontSize: "14px" }}>27/8/2020 | 5:00 pm</span>
                          </div>
                        </div>
                      </Nav.Link>
                    </Nav.Item>

                    <Nav.Item>
                      <Nav.Link eventKey="4">
                        <div className=" rounded-2 p-3" style={{ background: '#F6F4F4', borderLeft: "solid 6px #005BE7", borderRadius: "none" }}>

                          <div className="d-flex flex-column gap-1">
                            <span className="">4. Operation Theater (OT) Management Module </span>
                            <span style={{ color: "#959292", fontSize: "14px" }}>27/8/2020 | 5:00 pm</span>
                          </div>
                        </div>
                      </Nav.Link>
                    </Nav.Item>

                    <Nav.Item>
                      <Nav.Link eventKey="5">
                        <div className=" rounded-2 p-3 " style={{ background: '#F6F4F4', borderLeft: "solid 6px #005BE7", borderRadius: "none" }}>

                          <div className="d-flex flex-column gap-1">
                            <span className="">5. Lab & Diagnostic Module</span>
                            <span style={{ color: "#959292", fontSize: "14px" }}>27/8/2020 | 5:00 pm</span>
                          </div>
                        </div>
                      </Nav.Link>
                    </Nav.Item>

                    <Nav.Item>
                      <Nav.Link eventKey="6">
                        <div className=" rounded-2 p-3" style={{ background: '#F6F4F4', borderLeft: "solid 6px #005BE7", borderRadius: "none" }}>

                          <div className="d-flex flex-column gap-1">
                            <span className="">6. Department Management Module </span>
                            <span style={{ color: "#959292", fontSize: "14px" }}>27/8/2020 | 5:00 pm</span>
                          </div>
                        </div>
                      </Nav.Link>
                    </Nav.Item>

                    <Nav.Item>
                      <Nav.Link eventKey="7">
                        <div className=" rounded-2 p-3" style={{ background: '#F6F4F4', borderLeft: "solid 6px #005BE7", borderRadius: "none" }}>

                          <div className="d-flex flex-column gap-1">
                            <span className="">7.  Pharmacy & Medication Module </span>
                            <span style={{ color: "#959292", fontSize: "14px" }}>27/8/2020 | 5:00 pm</span>
                          </div>
                        </div>
                      </Nav.Link>
                    </Nav.Item>

                    <Nav.Item>
                      <Nav.Link eventKey="8">
                        <div className=" rounded-2 p-3 mb-3" style={{ background: '#F6F4F4', borderLeft: "solid 6px #005BE7", borderRadius: "none" }}>

                          <div className="d-flex flex-column gap-1">
                            <span className="">8. Treatment Management Module</span>
                            <span style={{ color: "#959292", fontSize: "14px" }}>27/8/2020 | 5:00 pm</span>
                          </div>
                        </div>
                      </Nav.Link>
                    </Nav.Item>

                    <Nav.Item>
                      <Nav.Link eventKey="9">
                        <div className=" rounded-2 p-3 " style={{ background: '#F6F4F4', borderLeft: "solid 6px #005BE7", borderRadius: "none" }}>

                          <div className="d-flex flex-column gap-1">
                            <span className="">9. Follow-Up & Reminder Module</span>
                            <span style={{ color: "#959292", fontSize: "14px" }}>27/8/2020 | 5:00 pm</span>
                          </div>
                        </div>
                      </Nav.Link>
                    </Nav.Item>

                    <Nav.Item>
                      <Nav.Link eventKey="10">
                        <div className=" rounded-2 p-3" style={{ background: '#F6F4F4', borderLeft: "solid 6px #005BE7", borderRadius: "none" }}>

                          <div className="d-flex flex-column gap-1">
                            <span className="">10. Internal Resource Management Module</span>
                            <span style={{ color: "#959292", fontSize: "14px" }}>27/8/2020 | 5:00 pm</span>
                          </div>
                        </div>
                      </Nav.Link>
                    </Nav.Item>

                    <Nav.Item>
                      <Nav.Link eventKey="11">
                        <div className=" rounded-2 p-3 " style={{ background: '#F6F4F4', borderLeft: "solid 6px #005BE7", borderRadius: "none" }}>

                          <div className="d-flex flex-column gap-1">
                            <span className="">11. Consent Management Module </span>
                            <span style={{ color: "#959292", fontSize: "14px" }}>27/8/2020 | 5:00 pm</span>
                          </div>
                        </div>
                      </Nav.Link>
                    </Nav.Item>

                    <Nav.Item>
                      <Nav.Link eventKey="12">
                        <div className=" rounded-2 p-3" style={{ background: '#F6F4F4', borderLeft: "solid 6px #005BE7", borderRadius: "none" }}>

                          <div className="d-flex flex-column gap-1">
                            <span className="">12. Analytics & Reporting Module</span>
                            <span style={{ color: "#959292", fontSize: "14px" }}>27/8/2020 | 5:00 pm</span>
                          </div>
                        </div>
                      </Nav.Link>
                    </Nav.Item>

                    <Nav.Item>
                      <Nav.Link eventKey="13">
                        <div className=" rounded-2 p-3" style={{ background: '#F6F4F4', borderLeft: "solid 6px #005BE7", borderRadius: "none" }}>

                          <div className="d-flex flex-column gap-1">
                            <span className="">13. Notifications & Alerts Module</span>
                            <span style={{ color: "#959292", fontSize: "14px" }}>27/8/2020 | 5:00 pm</span>
                          </div>
                        </div>
                      </Nav.Link>
                    </Nav.Item>


                    <Nav.Item>
                      <Nav.Link eventKey="14">
                        <div className=" rounded-2 p-3" style={{ background: '#F6F4F4', borderLeft: "solid 6px #005BE7", borderRadius: "none" }}>

                          <div className="d-flex flex-column gap-1">
                            <span className="">14. User & Role Management Module</span>
                            <span style={{ color: "#959292", fontSize: "14px" }}>27/8/2020 | 5:00 pm</span>
                          </div>
                        </div>
                      </Nav.Link>
                    </Nav.Item>
                  </Nav>



                  <div className="mb-4 text-start p-2">
                    <button className="div-ButtonGreen " type="submit">Submit</button>
                  </div>
                </Col>

                <Col md={6} style={{ background: "#D9D9D9 !important", borderRadius: ".3rem !important" }}>

                  <div className="d-flex justify-content-start mb-4">
                    <div className="d-flex justify-content-center" >
                      <span className="" style={{ fontSize: "20px" }}>Sub Modules</span>
                    </div>
                  </div>

                  <Tab.Content >
                    <Tab.Pane eventKey="1">
                      <div className=" rounded-2 p-3 mb-3" style={{ background: '#F6F4F4', borderLeft: "solid 6px #005BE7", borderRadius: "none" }}>



                        <div className="d-flex align-items-start justify-content-between flex-wrap gap-1 ">
                          <div className="d-flex flex-column gap-1">
                            <span className="">1.	Patient Registration</span>
                            <span style={{ color: "#959292" }}>27/8/2020 | 5:00 pm</span>
                          </div>

                          <Form>
                            {['checkbox'].map((type) => (
                              <div key={`default-${type}`} className="mb-3">
                                <Form.Check // prettier-ignore
                                  type={type}
                                  id={`default-${type}`}
                                />
                              </div>
                            ))}
                          </Form>
                        </div>

                      </div>

                      <div className=" rounded-2 p-3 mb-3" style={{ background: '#F6F4F4', borderLeft: "solid 6px #005BE7", borderRadius: "none" }}>

                        <div className="d-flex align-items-start justify-content-between flex-wrap gap-1 ">
                          <div className="d-flex flex-column gap-1">
                            <span className="">2.	Patient Case History</span>
                            <span style={{ color: "#959292" }}>27/8/2020 | 5:00 pm</span>
                          </div>

                          <Form>
                            {['checkbox'].map((type) => (
                              <div key={`default-${type}`} className="mb-3">
                                <Form.Check // prettier-ignore
                                  type={type}
                                  id={`default-${type}`}
                                />
                              </div>
                            ))}
                          </Form>
                        </div>

                      </div>

                      <div className=" rounded-2 p-3 mb-3" style={{ background: '#F6F4F4', borderLeft: "solid 6px #005BE7", borderRadius: "none" }}>



                        <div className="d-flex align-items-start justify-content-between flex-wrap gap-1 ">
                          <div className="d-flex flex-column gap-1">
                            <span className="">3.	Appointment History</span>
                            <span style={{ color: "#959292" }}>27/8/2020 | 5:00 pm</span>
                          </div>

                          <Form>
                            {['checkbox'].map((type) => (
                              <div key={`default-${type}`} className="mb-3">
                                <Form.Check // prettier-ignore
                                  type={type}
                                  id={`default-${type}`}
                                />
                              </div>
                            ))}
                          </Form>
                        </div>

                      </div>

                      <div className=" rounded-2 p-3 mb-3" style={{ background: '#F6F4F4', borderLeft: "solid 6px #005BE7", borderRadius: "none" }}>


                        <div className="d-flex align-items-start justify-content-between flex-wrap gap-1 ">
                          <div className="d-flex flex-column gap-1">
                            <span className="">4.	Follow-Up Management</span>
                            <span style={{ color: "#959292" }}>27/8/2020 | 5:00 pm</span>
                          </div>

                          <Form>
                            {['checkbox'].map((type) => (
                              <div key={`default-${type}`} className="mb-3">
                                <Form.Check // prettier-ignore
                                  type={type}
                                  id={`default-${type}`}
                                />
                              </div>
                            ))}
                          </Form>
                        </div>

                      </div>

                      <div className=" rounded-2 p-3 mb-3" style={{ background: '#F6F4F4', borderLeft: "solid 6px #005BE7", borderRadius: "none" }}>



                        <div className="d-flex align-items-start justify-content-between flex-wrap gap-1 ">
                          <div className="d-flex flex-column gap-1">
                            <span className="">5.	Emergency Contact Management</span>
                            <span style={{ color: "#959292" }}>27/8/2020 | 5:00 pm</span>
                          </div>

                          <Form>
                            {['checkbox'].map((type) => (
                              <div key={`default-${type}`} className="mb-3">
                                <Form.Check // prettier-ignore
                                  type={type}
                                  id={`default-${type}`}
                                />
                              </div>
                            ))}
                          </Form>
                        </div>

                      </div>

                      <div className=" rounded-2 p-3 mb-3" style={{ background: '#F6F4F4', borderLeft: "solid 6px #005BE7", borderRadius: "none" }}>



                        <div className="d-flex align-items-start justify-content-between flex-wrap gap-1 ">
                          <div className="d-flex flex-column gap-1">
                            <span className="">6.	Consent Forms Management</span>
                            <span style={{ color: "#959292" }}>27/8/2020 | 5:00 pm</span>
                          </div>

                          <Form>
                            {['checkbox'].map((type) => (
                              <div key={`default-${type}`} className="mb-3">
                                <Form.Check // prettier-ignore
                                  type={type}
                                  id={`default-${type}`}
                                />
                              </div>
                            ))}
                          </Form>
                        </div>

                      </div>

                    </Tab.Pane>

                    <Tab.Pane eventKey="2">

                      <div className=" rounded-2 p-3 mb-3" style={{ background: '#F6F4F4', borderLeft: "solid 6px #005BE7", borderRadius: "none" }}>



                        <div className="d-flex align-items-start justify-content-between flex-wrap gap-1 ">
                          <div className="d-flex flex-column gap-1">
                            <span className="">1.	Online Appointment Booking</span>
                            <span style={{ color: "#959292" }}>27/8/2020 | 5:00 pm</span>
                          </div>

                          <Form>
                            {['checkbox'].map((type) => (
                              <div key={`default-${type}`} className="mb-3">
                                <Form.Check // prettier-ignore
                                  type={type}
                                  id={`default-${type}`}
                                />
                              </div>
                            ))}
                          </Form>
                        </div>

                      </div>

                      <div className=" rounded-2 p-3 mb-3" style={{ background: '#F6F4F4', borderLeft: "solid 6px #005BE7", borderRadius: "none" }}>



                        <div className="d-flex align-items-start justify-content-between flex-wrap gap-1 ">
                          <div className="d-flex flex-column gap-1">
                            <span className="">2.	Appointment Rescheduling and Cancellation</span>
                            <span style={{ color: "#959292" }}>27/8/2020 | 5:00 pm</span>
                          </div>

                          <Form>
                            {['checkbox'].map((type) => (
                              <div key={`default-${type}`} className="mb-3">
                                <Form.Check // prettier-ignore
                                  type={type}
                                  id={`default-${type}`}
                                />
                              </div>
                            ))}
                          </Form>
                        </div>

                      </div>

                      <div className=" rounded-2 p-3 mb-3" style={{ background: '#F6F4F4', borderLeft: "solid 6px #005BE7", borderRadius: "none" }}>



                        <div className="d-flex align-items-start justify-content-between flex-wrap gap-1 ">
                          <div className="d-flex flex-column gap-1">
                            <span className="">3.	Doctor Availability Management</span>
                            <span style={{ color: "#959292" }}>27/8/2020 | 5:00 pm</span>
                          </div>

                          <Form>
                            {['checkbox'].map((type) => (
                              <div key={`default-${type}`} className="mb-3">
                                <Form.Check // prettier-ignore
                                  type={type}
                                  id={`default-${type}`}
                                />
                              </div>
                            ))}
                          </Form>
                        </div>

                      </div>

                      <div className=" rounded-2 p-3 mb-3" style={{ background: '#F6F4F4', borderLeft: "solid 6px #005BE7", borderRadius: "none" }}>


                        <div className="d-flex align-items-start justify-content-between flex-wrap gap-1 ">
                          <div className="d-flex flex-column gap-1">
                            <span className="">4.	Teleconsultation (Video/Audio Consultations)</span>
                            <span style={{ color: "#959292" }}>27/8/2020 | 5:00 pm</span>
                          </div>

                          <Form>
                            {['checkbox'].map((type) => (
                              <div key={`default-${type}`} className="mb-3">
                                <Form.Check // prettier-ignore
                                  type={type}
                                  id={`default-${type}`}
                                />
                              </div>
                            ))}
                          </Form>
                        </div>

                      </div>

                      <div className=" rounded-2 p-3 mb-3" style={{ background: '#F6F4F4', borderLeft: "solid 6px #005BE7", borderRadius: "none" }}>



                        <div className="d-flex align-items-start justify-content-between flex-wrap gap-1 ">
                          <div className="d-flex flex-column gap-1">
                            <span className="">5.	Appointment Reminders</span>
                            <span style={{ color: "#959292" }}>27/8/2020 | 5:00 pm</span>
                          </div>

                          <Form>
                            {['checkbox'].map((type) => (
                              <div key={`default-${type}`} className="mb-3">
                                <Form.Check // prettier-ignore
                                  type={type}
                                  id={`default-${type}`}
                                />
                              </div>
                            ))}
                          </Form>
                        </div>

                      </div>


                      <div className=" rounded-2 p-3 mb-3" style={{ background: '#F6F4F4', borderLeft: "solid 6px #005BE7", borderRadius: "none" }}>



                        <div className="d-flex align-items-start justify-content-between flex-wrap gap-1 ">
                          <div className="d-flex flex-column gap-1">
                            <span className="">6.	Consultation Notes and Prescription Management</span>
                            <span style={{ color: "#959292" }}>27/8/2020 | 5:00 pm</span>
                          </div>

                          <Form>
                            {['checkbox'].map((type) => (
                              <div key={`default-${type}`} className="mb-3">
                                <Form.Check // prettier-ignore
                                  type={type}
                                  id={`default-${type}`}
                                />
                              </div>
                            ))}
                          </Form>
                        </div>

                      </div>

                    </Tab.Pane>

                    <Tab.Pane eventKey="3">


                      <div className=" rounded-2 p-3 mb-3" style={{ background: '#F6F4F4', borderLeft: "solid 6px #005BE7", borderRadius: "none" }}>



                        <div className="d-flex align-items-start justify-content-between flex-wrap gap-1 ">
                          <div className="d-flex flex-column gap-1">
                            <span className="">1.	Patient Billing</span>
                            <span style={{ color: "#959292" }}>27/8/2020 | 5:00 pm</span>
                          </div>

                          <Form>
                            {['checkbox'].map((type) => (
                              <div key={`default-${type}`} className="mb-3">
                                <Form.Check // prettier-ignore
                                  type={type}
                                  id={`default-${type}`}
                                />
                              </div>
                            ))}
                          </Form>
                        </div>

                      </div>

                      <div className=" rounded-2 p-3 mb-3" style={{ background: '#F6F4F4', borderLeft: "solid 6px #005BE7", borderRadius: "none" }}>



                        <div className="d-flex align-items-start justify-content-between flex-wrap gap-1 ">
                          <div className="d-flex flex-column gap-1">
                            <span className="">2.	Payment Gateway Integration</span>
                            <span style={{ color: "#959292" }}>27/8/2020 | 5:00 pm</span>
                          </div>

                          <Form>
                            {['checkbox'].map((type) => (
                              <div key={`default-${type}`} className="mb-3">
                                <Form.Check // prettier-ignore
                                  type={type}
                                  id={`default-${type}`}
                                />
                              </div>
                            ))}
                          </Form>
                        </div>

                      </div>

                      <div className=" rounded-2 p-3 mb-3" style={{ background: '#F6F4F4', borderLeft: "solid 6px #005BE7", borderRadius: "none" }}>


                        <div className="d-flex align-items-start justify-content-between flex-wrap gap-1 ">
                          <div className="d-flex flex-column gap-1">
                            <span className="">3.	Insurance Claims Management</span>
                            <span style={{ color: "#959292" }}>27/8/2020 | 5:00 pm</span>
                          </div>

                          <Form>
                            {['checkbox'].map((type) => (
                              <div key={`default-${type}`} className="mb-3">
                                <Form.Check // prettier-ignore
                                  type={type}
                                  id={`default-${type}`}
                                />
                              </div>
                            ))}
                          </Form>
                        </div>

                      </div>

                      <div className=" rounded-2 p-3 mb-3" style={{ background: '#F6F4F4', borderLeft: "solid 6px #005BE7", borderRadius: "none" }}>



                        <div className="d-flex align-items-start justify-content-between flex-wrap gap-1 ">
                          <div className="d-flex flex-column gap-1">
                            <span className="">4.	Refund Management</span>
                            <span style={{ color: "#959292" }}>27/8/2020 | 5:00 pm</span>
                          </div>

                          <Form>
                            {['checkbox'].map((type) => (
                              <div key={`default-${type}`} className="mb-3">
                                <Form.Check // prettier-ignore
                                  type={type}
                                  id={`default-${type}`}
                                />
                              </div>
                            ))}
                          </Form>
                        </div>

                      </div>


                      <div className=" rounded-2 p-3 mb-3" style={{ background: '#F6F4F4', borderLeft: "solid 6px #005BE7", borderRadius: "none" }}>



                        <div className="d-flex align-items-start justify-content-between flex-wrap gap-1 ">
                          <div className="d-flex flex-column gap-1">
                            <span className="">5.	Payment History and Invoicing</span>
                            <span style={{ color: "#959292" }}>27/8/2020 | 5:00 pm</span>
                          </div>

                          <Form>
                            {['checkbox'].map((type) => (
                              <div key={`default-${type}`} className="mb-3">
                                <Form.Check // prettier-ignore
                                  type={type}
                                  id={`default-${type}`}
                                />
                              </div>
                            ))}
                          </Form>
                        </div>

                      </div>


                      <div className=" rounded-2 p-3 mb-3" style={{ background: '#F6F4F4', borderLeft: "solid 6px #005BE7", borderRadius: "none" }}>



                        <div className="d-flex align-items-start justify-content-between flex-wrap gap-1 ">
                          <div className="d-flex flex-column gap-1">
                            <span className="">6.	Pharmacy Billing Integration</span>
                            <span style={{ color: "#959292" }}>27/8/2020 | 5:00 pm</span>
                          </div>

                          <Form>
                            {['checkbox'].map((type) => (
                              <div key={`default-${type}`} className="mb-3">
                                <Form.Check // prettier-ignore
                                  type={type}
                                  id={`default-${type}`}
                                />
                              </div>
                            ))}
                          </Form>
                        </div>

                      </div>

                    </Tab.Pane>

                    <Tab.Pane eventKey="4">

                      <div className=" rounded-2 p-3 mb-3" style={{ background: '#F6F4F4', borderLeft: "solid 6px #005BE7", borderRadius: "none" }}>



                        <div className="d-flex align-items-start justify-content-between flex-wrap gap-1 ">
                          <div className="d-flex flex-column gap-1">
                            <span className="">1.	OT Scheduling and Booking</span>
                            <span style={{ color: "#959292" }}>27/8/2020 | 5:00 pm</span>
                          </div>

                          <Form>
                            {['checkbox'].map((type) => (
                              <div key={`default-${type}`} className="mb-3">
                                <Form.Check // prettier-ignore
                                  type={type}
                                  id={`default-${type}`}
                                />
                              </div>
                            ))}
                          </Form>
                        </div>

                      </div>

                      <div className=" rounded-2 p-3 mb-3" style={{ background: '#F6F4F4', borderLeft: "solid 6px #005BE7", borderRadius: "none" }}>



                        <div className="d-flex align-items-start justify-content-between flex-wrap gap-1 ">
                          <div className="d-flex flex-column gap-1">
                            <span className="">2.	OT Availability and Conflict Resolution</span>
                            <span style={{ color: "#959292" }}>27/8/2020 | 5:00 pm</span>
                          </div>

                          <Form>
                            {['checkbox'].map((type) => (
                              <div key={`default-${type}`} className="mb-3">
                                <Form.Check // prettier-ignore
                                  type={type}
                                  id={`default-${type}`}
                                />
                              </div>
                            ))}
                          </Form>
                        </div>

                      </div>

                      <div className=" rounded-2 p-3 mb-3" style={{ background: '#F6F4F4', borderLeft: "solid 6px #005BE7", borderRadius: "none" }}>



                        <div className="d-flex align-items-start justify-content-between flex-wrap gap-1 ">
                          <div className="d-flex flex-column gap-1">
                            <span className="">3.	Pre-Surgery Equipment Checklist</span>
                            <span style={{ color: "#959292" }}>27/8/2020 | 5:00 pm</span>
                          </div>

                          <Form>
                            {['checkbox'].map((type) => (
                              <div key={`default-${type}`} className="mb-3">
                                <Form.Check // prettier-ignore
                                  type={type}
                                  id={`default-${type}`}
                                />
                              </div>
                            ))}
                          </Form>
                        </div>

                      </div>

                      <div className=" rounded-2 p-3 mb-3" style={{ background: '#F6F4F4', borderLeft: "solid 6px #005BE7", borderRadius: "none" }}>


                        <div className="d-flex align-items-start justify-content-between flex-wrap gap-1 ">
                          <div className="d-flex flex-column gap-1">
                            <span className="">4.	Surgery Notes Management</span>
                            <span style={{ color: "#959292" }}>27/8/2020 | 5:00 pm</span>
                          </div>

                          <Form>
                            {['checkbox'].map((type) => (
                              <div key={`default-${type}`} className="mb-3">
                                <Form.Check // prettier-ignore
                                  type={type}
                                  id={`default-${type}`}
                                />
                              </div>
                            ))}
                          </Form>
                        </div>

                      </div>

                      <div className=" rounded-2 p-3 mb-3" style={{ background: '#F6F4F4', borderLeft: "solid 6px #005BE7", borderRadius: "none" }}>



                        <div className="d-flex align-items-start justify-content-between flex-wrap gap-1 ">
                          <div className="d-flex flex-column gap-1">
                            <span className="">5.	Post-Operative Care Management</span>
                            <span style={{ color: "#959292" }}>27/8/2020 | 5:00 pm</span>
                          </div>

                          <Form>
                            {['checkbox'].map((type) => (
                              <div key={`default-${type}`} className="mb-3">
                                <Form.Check // prettier-ignore
                                  type={type}
                                  id={`default-${type}`}
                                />
                              </div>
                            ))}
                          </Form>
                        </div>

                      </div>


                      <div className=" rounded-2 p-3 mb-3" style={{ background: '#F6F4F4', borderLeft: "solid 6px #005BE7", borderRadius: "none" }}>



                        <div className="d-flex align-items-start justify-content-between flex-wrap gap-1 ">
                          <div className="d-flex flex-column gap-1">
                            <span className="">6.	OT Utilization Analytics</span>
                            <span style={{ color: "#959292" }}>27/8/2020 | 5:00 pm</span>
                          </div>

                          <Form>
                            {['checkbox'].map((type) => (
                              <div key={`default-${type}`} className="mb-3">
                                <Form.Check // prettier-ignore
                                  type={type}
                                  id={`default-${type}`}
                                />
                              </div>
                            ))}
                          </Form>
                        </div>

                      </div>

                    </Tab.Pane>

                    <Tab.Pane eventKey="5">
                      <div className=" rounded-2 p-3 mb-3" style={{ background: '#F6F4F4', borderLeft: "solid 6px #005BE7", borderRadius: "none" }}>



                        <div className="d-flex align-items-start justify-content-between flex-wrap gap-1 ">
                          <div className="d-flex flex-column gap-1">
                            <span className="">1.	Lab Test Scheduling</span>
                            <span style={{ color: "#959292" }}>27/8/2020 | 5:00 pm</span>
                          </div>

                          <Form>
                            {['checkbox'].map((type) => (
                              <div key={`default-${type}`} className="mb-3">
                                <Form.Check // prettier-ignore
                                  type={type}
                                  id={`default-${type}`}
                                />
                              </div>
                            ))}
                          </Form>
                        </div>

                      </div>

                      <div className=" rounded-2 p-3 mb-3" style={{ background: '#F6F4F4', borderLeft: "solid 6px #005BE7", borderRadius: "none" }}>



                        <div className="d-flex align-items-start justify-content-between flex-wrap gap-1 ">
                          <div className="d-flex flex-column gap-1">
                            <span className="">2.	Sample Collection Management</span>
                            <span style={{ color: "#959292" }}>27/8/2020 | 5:00 pm</span>
                          </div>

                          <Form>
                            {['checkbox'].map((type) => (
                              <div key={`default-${type}`} className="mb-3">
                                <Form.Check // prettier-ignore
                                  type={type}
                                  id={`default-${type}`}
                                />
                              </div>
                            ))}
                          </Form>
                        </div>

                      </div>

                      <div className=" rounded-2 p-3 mb-3" style={{ background: '#F6F4F4', borderLeft: "solid 6px #005BE7", borderRadius: "none" }}>



                        <div className="d-flex align-items-start justify-content-between flex-wrap gap-1 ">
                          <div className="d-flex flex-column gap-1">
                            <span className="">3.	Test Processing and Tracking</span>
                            <span style={{ color: "#959292" }}>27/8/2020 | 5:00 pm</span>
                          </div>

                          <Form>
                            {['checkbox'].map((type) => (
                              <div key={`default-${type}`} className="mb-3">
                                <Form.Check // prettier-ignore
                                  type={type}
                                  id={`default-${type}`}
                                />
                              </div>
                            ))}
                          </Form>
                        </div>

                      </div>

                      <div className=" rounded-2 p-3 mb-3" style={{ background: '#F6F4F4', borderLeft: "solid 6px #005BE7", borderRadius: "none" }}>


                        <div className="d-flex align-items-start justify-content-between flex-wrap gap-1 ">
                          <div className="d-flex flex-column gap-1">
                            <span className="">4.	Lab Report Generation and Sharing</span>
                            <span style={{ color: "#959292" }}>27/8/2020 | 5:00 pm</span>
                          </div>

                          <Form>
                            {['checkbox'].map((type) => (
                              <div key={`default-${type}`} className="mb-3">
                                <Form.Check // prettier-ignore
                                  type={type}
                                  id={`default-${type}`}
                                />
                              </div>
                            ))}
                          </Form>
                        </div>

                      </div>

                      <div className=" rounded-2 p-3 mb-3" style={{ background: '#F6F4F4', borderLeft: "solid 6px #005BE7", borderRadius: "none" }}>



                        <div className="d-flex align-items-start justify-content-between flex-wrap gap-1 ">
                          <div className="d-flex flex-column gap-1">
                            <span className="">5.	Diagnostic Test History</span>
                            <span style={{ color: "#959292" }}>27/8/2020 | 5:00 pm</span>
                          </div>

                          <Form>
                            {['checkbox'].map((type) => (
                              <div key={`default-${type}`} className="mb-3">
                                <Form.Check // prettier-ignore
                                  type={type}
                                  id={`default-${type}`}
                                />
                              </div>
                            ))}
                          </Form>
                        </div>

                      </div>

                      <div className=" rounded-2 p-3 mb-3" style={{ background: '#F6F4F4', borderLeft: "solid 6px #005BE7", borderRadius: "none" }}>



                        <div className="d-flex align-items-start justify-content-between flex-wrap gap-1 ">
                          <div className="d-flex flex-column gap-1">
                            <span className="">6.	Lab Inventory Management</span>
                            <span style={{ color: "#959292" }}>27/8/2020 | 5:00 pm</span>
                          </div>

                          <Form>
                            {['checkbox'].map((type) => (
                              <div key={`default-${type}`} className="mb-3">
                                <Form.Check // prettier-ignore
                                  type={type}
                                  id={`default-${type}`}
                                />
                              </div>
                            ))}
                          </Form>
                        </div>

                      </div>

                    </Tab.Pane>

                    <Tab.Pane eventKey="6">

                      <div className=" rounded-2 p-3 mb-3" style={{ background: '#F6F4F4', borderLeft: "solid 6px #005BE7", borderRadius: "none" }}>



                        <div className="d-flex align-items-start justify-content-between flex-wrap gap-1 ">
                          <div className="d-flex flex-column gap-1">
                            <span className="">1.	Add New Departments</span>
                            <span style={{ color: "#959292" }}>27/8/2020 | 5:00 pm</span>
                          </div>

                          <Form>
                            {['checkbox'].map((type) => (
                              <div key={`default-${type}`} className="mb-3">
                                <Form.Check // prettier-ignore
                                  type={type}
                                  id={`default-${type}`}
                                />
                              </div>
                            ))}
                          </Form>
                        </div>

                      </div>

                      <div className=" rounded-2 p-3 mb-3" style={{ background: '#F6F4F4', borderLeft: "solid 6px #005BE7", borderRadius: "none" }}>



                        <div className="d-flex align-items-start justify-content-between flex-wrap gap-1 ">
                          <div className="d-flex flex-column gap-1">
                            <span className="">2.	Department Resource Allocation</span>
                            <span style={{ color: "#959292" }}>27/8/2020 | 5:00 pm</span>
                          </div>

                          <Form>
                            {['checkbox'].map((type) => (
                              <div key={`default-${type}`} className="mb-3">
                                <Form.Check // prettier-ignore
                                  type={type}
                                  id={`default-${type}`}
                                />
                              </div>
                            ))}
                          </Form>
                        </div>

                      </div>

                      <div className=" rounded-2 p-3 mb-3" style={{ background: '#F6F4F4', borderLeft: "solid 6px #005BE7", borderRadius: "none" }}>



                        <div className="d-flex align-items-start justify-content-between flex-wrap gap-1 ">
                          <div className="d-flex flex-column gap-1">
                            <span className="">3.	Department Schedules</span>
                            <span style={{ color: "#959292" }}>27/8/2020 | 5:00 pm</span>
                          </div>

                          <Form>
                            {['checkbox'].map((type) => (
                              <div key={`default-${type}`} className="mb-3">
                                <Form.Check // prettier-ignore
                                  type={type}
                                  id={`default-${type}`}
                                />
                              </div>
                            ))}
                          </Form>
                        </div>

                      </div>

                      <div className=" rounded-2 p-3 mb-3" style={{ background: '#F6F4F4', borderLeft: "solid 6px #005BE7", borderRadius: "none" }}>


                        <div className="d-flex align-items-start justify-content-between flex-wrap gap-1 ">
                          <div className="d-flex flex-column gap-1">
                            <span className="">4.	Department Billing and Expenses</span>
                            <span style={{ color: "#959292" }}>27/8/2020 | 5:00 pm</span>
                          </div>

                          <Form>
                            {['checkbox'].map((type) => (
                              <div key={`default-${type}`} className="mb-3">
                                <Form.Check // prettier-ignore
                                  type={type}
                                  id={`default-${type}`}
                                />
                              </div>
                            ))}
                          </Form>
                        </div>

                      </div>

                      <div className=" rounded-2 p-3 mb-3" style={{ background: '#F6F4F4', borderLeft: "solid 6px #005BE7", borderRadius: "none" }}>



                        <div className="d-flex align-items-start justify-content-between flex-wrap gap-1 ">
                          <div className="d-flex flex-column gap-1">
                            <span className="">5.	Treatment Protocol Management</span>
                            <span style={{ color: "#959292" }}>27/8/2020 | 5:00 pm</span>
                          </div>

                          <Form>
                            {['checkbox'].map((type) => (
                              <div key={`default-${type}`} className="mb-3">
                                <Form.Check // prettier-ignore
                                  type={type}
                                  id={`default-${type}`}
                                />
                              </div>
                            ))}
                          </Form>
                        </div>

                      </div>



                      <div className=" rounded-2 p-3 mb-3" style={{ background: '#F6F4F4', borderLeft: "solid 6px #005BE7", borderRadius: "none" }}>



                        <div className="d-flex align-items-start justify-content-between flex-wrap gap-1 ">
                          <div className="d-flex flex-column gap-1">
                            <span className="">6.	Department Performance Reports</span>
                            <span style={{ color: "#959292" }}>27/8/2020 | 5:00 pm</span>
                          </div>

                          <Form>
                            {['checkbox'].map((type) => (
                              <div key={`default-${type}`} className="mb-3">
                                <Form.Check // prettier-ignore
                                  type={type}
                                  id={`default-${type}`}
                                />
                              </div>
                            ))}
                          </Form>
                        </div>

                      </div>

                    </Tab.Pane>

                    <Tab.Pane eventKey="7">
                      <div className=" rounded-2 p-3 mb-3" style={{ background: '#F6F4F4', borderLeft: "solid 6px #005BE7", borderRadius: "none" }}>



                        <div className="d-flex align-items-start justify-content-between flex-wrap gap-1 ">
                          <div className="d-flex flex-column gap-1">
                            <span className="">1.	Pharmacy Stock Management</span>
                            <span style={{ color: "#959292" }}>27/8/2020 | 5:00 pm</span>
                          </div>

                          <Form>
                            {['checkbox'].map((type) => (
                              <div key={`default-${type}`} className="mb-3">
                                <Form.Check // prettier-ignore
                                  type={type}
                                  id={`default-${type}`}
                                />
                              </div>
                            ))}
                          </Form>
                        </div>

                      </div>

                      <div className=" rounded-2 p-3 mb-3" style={{ background: '#F6F4F4', borderLeft: "solid 6px #005BE7", borderRadius: "none" }}>



                        <div className="d-flex align-items-start justify-content-between flex-wrap gap-1 ">
                          <div className="d-flex flex-column gap-1">
                            <span className="">2.	Expiry and Low Stock Alerts  </span>
                            <span style={{ color: "#959292" }}>27/8/2020 | 5:00 pm</span>
                          </div>

                          <Form>
                            {['checkbox'].map((type) => (
                              <div key={`default-${type}`} className="mb-3">
                                <Form.Check // prettier-ignore
                                  type={type}
                                  id={`default-${type}`}
                                />
                              </div>
                            ))}
                          </Form>
                        </div>

                      </div>

                      <div className=" rounded-2 p-3 mb-3" style={{ background: '#F6F4F4', borderLeft: "solid 6px #005BE7", borderRadius: "none" }}>



                        <div className="d-flex align-items-start justify-content-between flex-wrap gap-1 ">
                          <div className="d-flex flex-column gap-1">
                            <span className="">3.	Prescription Fulfillment</span>
                            <span style={{ color: "#959292" }}>27/8/2020 | 5:00 pm</span>
                          </div>

                          <Form>
                            {['checkbox'].map((type) => (
                              <div key={`default-${type}`} className="mb-3">
                                <Form.Check // prettier-ignore
                                  type={type}
                                  id={`default-${type}`}
                                />
                              </div>
                            ))}
                          </Form>
                        </div>

                      </div>

                      <div className=" rounded-2 p-3 mb-3" style={{ background: '#F6F4F4', borderLeft: "solid 6px #005BE7", borderRadius: "none" }}>


                        <div className="d-flex align-items-start justify-content-between flex-wrap gap-1 ">
                          <div className="d-flex flex-column gap-1">
                            <span className="">4.	Home Delivery Management</span>
                            <span style={{ color: "#959292" }}>27/8/2020 | 5:00 pm</span>
                          </div>

                          <Form>
                            {['checkbox'].map((type) => (
                              <div key={`default-${type}`} className="mb-3">
                                <Form.Check // prettier-ignore
                                  type={type}
                                  id={`default-${type}`}
                                />
                              </div>
                            ))}
                          </Form>
                        </div>

                      </div>

                      <div className=" rounded-2 p-3 mb-3" style={{ background: '#F6F4F4', borderLeft: "solid 6px #005BE7", borderRadius: "none" }}>



                        <div className="d-flex align-items-start justify-content-between flex-wrap gap-1 ">
                          <div className="d-flex flex-column gap-1">
                            <span className="">5.	Medication Billing</span>
                            <span style={{ color: "#959292" }}>27/8/2020 | 5:00 pm</span>
                          </div>

                          <Form>
                            {['checkbox'].map((type) => (
                              <div key={`default-${type}`} className="mb-3">
                                <Form.Check // prettier-ignore
                                  type={type}
                                  id={`default-${type}`}
                                />
                              </div>
                            ))}
                          </Form>
                        </div>

                      </div>


                      <div className=" rounded-2 p-3 mb-3" style={{ background: '#F6F4F4', borderLeft: "solid 6px #005BE7", borderRadius: "none" }}>



                        <div className="d-flex align-items-start justify-content-between flex-wrap gap-1 ">
                          <div className="d-flex flex-column gap-1">
                            <span className="">6.	Pharmacy Usage Analytics</span>
                            <span style={{ color: "#959292" }}>27/8/2020 | 5:00 pm</span>
                          </div>

                          <Form>
                            {['checkbox'].map((type) => (
                              <div key={`default-${type}`} className="mb-3">
                                <Form.Check // prettier-ignore
                                  type={type}
                                  id={`default-${type}`}
                                />
                              </div>
                            ))}
                          </Form>
                        </div>

                      </div>
                    </Tab.Pane>

                    <Tab.Pane eventKey="8">

                      <div className=" rounded-2 p-3 mb-3" style={{ background: '#F6F4F4', borderLeft: "solid 6px #005BE7", borderRadius: "none" }}>



                        <div className="d-flex align-items-start justify-content-between flex-wrap gap-1 ">
                          <div className="d-flex flex-column gap-1">
                            <span className="">1.	Treatment Protocols Management</span>
                            <span style={{ color: "#959292" }}>27/8/2020 | 5:00 pm</span>
                          </div>

                          <Form>
                            {['checkbox'].map((type) => (
                              <div key={`default-${type}`} className="mb-3">
                                <Form.Check // prettier-ignore
                                  type={type}
                                  id={`default-${type}`}
                                />
                              </div>
                            ))}
                          </Form>
                        </div>

                      </div>

                      <div className=" rounded-2 p-3 mb-3" style={{ background: '#F6F4F4', borderLeft: "solid 6px #005BE7", borderRadius: "none" }}>



                        <div className="d-flex align-items-start justify-content-between flex-wrap gap-1 ">
                          <div className="d-flex flex-column gap-1">
                            <span className="">2.	Inclusions and Exclusions for Treatments</span>
                            <span style={{ color: "#959292" }}>27/8/2020 | 5:00 pm</span>
                          </div>

                          <Form>
                            {['checkbox'].map((type) => (
                              <div key={`default-${type}`} className="mb-3">
                                <Form.Check // prettier-ignore
                                  type={type}
                                  id={`default-${type}`}
                                />
                              </div>
                            ))}
                          </Form>
                        </div>

                      </div>

                      <div className=" rounded-2 p-3 mb-3" style={{ background: '#F6F4F4', borderLeft: "solid 6px #005BE7", borderRadius: "none" }}>



                        <div className="d-flex align-items-start justify-content-between flex-wrap gap-1 ">
                          <div className="d-flex flex-column gap-1">
                            <span className="">3.	Custom Treatment Plans</span>
                            <span style={{ color: "#959292" }}>27/8/2020 | 5:00 pm</span>
                          </div>

                          <Form>
                            {['checkbox'].map((type) => (
                              <div key={`default-${type}`} className="mb-3">
                                <Form.Check // prettier-ignore
                                  type={type}
                                  id={`default-${type}`}
                                />
                              </div>
                            ))}
                          </Form>
                        </div>

                      </div>

                      <div className=" rounded-2 p-3 mb-3" style={{ background: '#F6F4F4', borderLeft: "solid 6px #005BE7", borderRadius: "none" }}>


                        <div className="d-flex align-items-start justify-content-between flex-wrap gap-1 ">
                          <div className="d-flex flex-column gap-1">
                            <span className="">4.	Progress Tracking and Notes</span>
                            <span style={{ color: "#959292" }}>27/8/2020 | 5:00 pm</span>
                          </div>

                          <Form>
                            {['checkbox'].map((type) => (
                              <div key={`default-${type}`} className="mb-3">
                                <Form.Check // prettier-ignore
                                  type={type}
                                  id={`default-${type}`}
                                />
                              </div>
                            ))}
                          </Form>
                        </div>

                      </div>

                      <div className=" rounded-2 p-3 mb-3" style={{ background: '#F6F4F4', borderLeft: "solid 6px #005BE7", borderRadius: "none" }}>



                        <div className="d-flex align-items-start justify-content-between flex-wrap gap-1 ">
                          <div className="d-flex flex-column gap-1">
                            <span className="">5.	Referral Management</span>
                            <span style={{ color: "#959292" }}>27/8/2020 | 5:00 pm</span>
                          </div>

                          <Form>
                            {['checkbox'].map((type) => (
                              <div key={`default-${type}`} className="mb-3">
                                <Form.Check // prettier-ignore
                                  type={type}
                                  id={`default-${type}`}
                                />
                              </div>
                            ))}
                          </Form>
                        </div>

                      </div>

                      <div className=" rounded-2 p-3 mb-3" style={{ background: '#F6F4F4', borderLeft: "solid 6px #005BE7", borderRadius: "none" }}>



                        <div className="d-flex align-items-start justify-content-between flex-wrap gap-1 ">
                          <div className="d-flex flex-column gap-1">
                            <span className="">6.	Treatment History</span>
                            <span style={{ color: "#959292" }}>27/8/2020 | 5:00 pm</span>
                          </div>

                          <Form>
                            {['checkbox'].map((type) => (
                              <div key={`default-${type}`} className="mb-3">
                                <Form.Check // prettier-ignore
                                  type={type}
                                  id={`default-${type}`}
                                />
                              </div>
                            ))}
                          </Form>
                        </div>

                      </div>

                    </Tab.Pane>

                    <Tab.Pane eventKey="9">
                      <div className=" rounded-2 p-3 mb-3" style={{ background: '#F6F4F4', borderLeft: "solid 6px #005BE7", borderRadius: "none" }}>



                        <div className="d-flex align-items-start justify-content-between flex-wrap gap-1 ">
                          <div className="d-flex flex-column gap-1">
                            <span className="">1.	Follow-Up Scheduling</span>
                            <span style={{ color: "#959292" }}>27/8/2020 | 5:00 pm</span>
                          </div>

                          <Form>
                            {['checkbox'].map((type) => (
                              <div key={`default-${type}`} className="mb-3">
                                <Form.Check // prettier-ignore
                                  type={type}
                                  id={`default-${type}`}
                                />
                              </div>
                            ))}
                          </Form>
                        </div>

                      </div>

                      <div className=" rounded-2 p-3 mb-3" style={{ background: '#F6F4F4', borderLeft: "solid 6px #005BE7", borderRadius: "none" }}>



                        <div className="d-flex align-items-start justify-content-between flex-wrap gap-1 ">
                          <div className="d-flex flex-column gap-1">
                            <span className="">2.	Follow-Up Notification Management</span>
                            <span style={{ color: "#959292" }}>27/8/2020 | 5:00 pm</span>
                          </div>

                          <Form>
                            {['checkbox'].map((type) => (
                              <div key={`default-${type}`} className="mb-3">
                                <Form.Check // prettier-ignore
                                  type={type}
                                  id={`default-${type}`}
                                />
                              </div>
                            ))}
                          </Form>
                        </div>

                      </div>

                      <div className=" rounded-2 p-3 mb-3" style={{ background: '#F6F4F4', borderLeft: "solid 6px #005BE7", borderRadius: "none" }}>



                        <div className="d-flex align-items-start justify-content-between flex-wrap gap-1 ">
                          <div className="d-flex flex-column gap-1">
                            <span className="">3.	Missed Follow-Up Alerts</span>
                            <span style={{ color: "#959292" }}>27/8/2020 | 5:00 pm</span>
                          </div>

                          <Form>
                            {['checkbox'].map((type) => (
                              <div key={`default-${type}`} className="mb-3">
                                <Form.Check // prettier-ignore
                                  type={type}
                                  id={`default-${type}`}
                                />
                              </div>
                            ))}
                          </Form>
                        </div>

                      </div>

                      <div className=" rounded-2 p-3 mb-3" style={{ background: '#F6F4F4', borderLeft: "solid 6px #005BE7", borderRadius: "none" }}>


                        <div className="d-flex align-items-start justify-content-between flex-wrap gap-1 ">
                          <div className="d-flex flex-column gap-1">
                            <span className="">4.	Recurring Follow-Ups</span>
                            <span style={{ color: "#959292" }}>27/8/2020 | 5:00 pm</span>
                          </div>

                          <Form>
                            {['checkbox'].map((type) => (
                              <div key={`default-${type}`} className="mb-3">
                                <Form.Check // prettier-ignore
                                  type={type}
                                  id={`default-${type}`}
                                />
                              </div>
                            ))}
                          </Form>
                        </div>

                      </div>

                      <div className=" rounded-2 p-3 mb-3" style={{ background: '#F6F4F4', borderLeft: "solid 6px #005BE7", borderRadius: "none" }}>



                        <div className="d-flex align-items-start justify-content-between flex-wrap gap-1 ">
                          <div className="d-flex flex-column gap-1">
                            <span className="">5.	Follow-Up History Reports</span>
                            <span style={{ color: "#959292" }}>27/8/2020 | 5:00 pm</span>
                          </div>

                          <Form>
                            {['checkbox'].map((type) => (
                              <div key={`default-${type}`} className="mb-3">
                                <Form.Check // prettier-ignore
                                  type={type}
                                  id={`default-${type}`}
                                />
                              </div>
                            ))}
                          </Form>
                        </div>

                      </div>



                      <div className=" rounded-2 p-3 mb-3" style={{ background: '#F6F4F4', borderLeft: "solid 6px #005BE7", borderRadius: "none" }}>



                        <div className="d-flex align-items-start justify-content-between flex-wrap gap-1 ">
                          <div className="d-flex flex-column gap-1">
                            <span className="">6.	Feedback Collection</span>
                            <span style={{ color: "#959292" }}>27/8/2020 | 5:00 pm</span>
                          </div>

                          <Form>
                            {['checkbox'].map((type) => (
                              <div key={`default-${type}`} className="mb-3">
                                <Form.Check // prettier-ignore
                                  type={type}
                                  id={`default-${type}`}
                                />
                              </div>
                            ))}
                          </Form>
                        </div>

                      </div>

                    </Tab.Pane>

                    <Tab.Pane eventKey="10">

                      <div className=" rounded-2 p-3 mb-3" style={{ background: '#F6F4F4', borderLeft: "solid 6px #005BE7", borderRadius: "none" }}>



                        <div className="d-flex align-items-start justify-content-between flex-wrap gap-1 ">
                          <div className="d-flex flex-column gap-1">
                            <span className="">1.	Bed Availability and Allocation</span>
                            <span style={{ color: "#959292" }}>27/8/2020 | 5:00 pm</span>
                          </div>

                          <Form>
                            {['checkbox'].map((type) => (
                              <div key={`default-${type}`} className="mb-3">
                                <Form.Check // prettier-ignore
                                  type={type}
                                  id={`default-${type}`}
                                />
                              </div>
                            ))}
                          </Form>
                        </div>

                      </div>

                      <div className=" rounded-2 p-3 mb-3" style={{ background: '#F6F4F4', borderLeft: "solid 6px #005BE7", borderRadius: "none" }}>



                        <div className="d-flex align-items-start justify-content-between flex-wrap gap-1 ">
                          <div className="d-flex flex-column gap-1">
                            <span className="">2.	ICU Resource Management</span>
                            <span style={{ color: "#959292" }}>27/8/2020 | 5:00 pm</span>
                          </div>

                          <Form>
                            {['checkbox'].map((type) => (
                              <div key={`default-${type}`} className="mb-3">
                                <Form.Check // prettier-ignore
                                  type={type}
                                  id={`default-${type}`}
                                />
                              </div>
                            ))}
                          </Form>
                        </div>

                      </div>

                      <div className=" rounded-2 p-3 mb-3" style={{ background: '#F6F4F4', borderLeft: "solid 6px #005BE7", borderRadius: "none" }}>



                        <div className="d-flex align-items-start justify-content-between flex-wrap gap-1 ">
                          <div className="d-flex flex-column gap-1">
                            <span className="">3.	Equipment Tracking</span>
                            <span style={{ color: "#959292" }}>27/8/2020 | 5:00 pm</span>
                          </div>

                          <Form>
                            {['checkbox'].map((type) => (
                              <div key={`default-${type}`} className="mb-3">
                                <Form.Check // prettier-ignore
                                  type={type}
                                  id={`default-${type}`}
                                />
                              </div>
                            ))}
                          </Form>
                        </div>

                      </div>

                      <div className=" rounded-2 p-3 mb-3" style={{ background: '#F6F4F4', borderLeft: "solid 6px #005BE7", borderRadius: "none" }}>


                        <div className="d-flex align-items-start justify-content-between flex-wrap gap-1 ">
                          <div className="d-flex flex-column gap-1">
                            <span className="">4.	Room Management</span>
                            <span style={{ color: "#959292" }}>27/8/2020 | 5:00 pm</span>
                          </div>

                          <Form>
                            {['checkbox'].map((type) => (
                              <div key={`default-${type}`} className="mb-3">
                                <Form.Check // prettier-ignore
                                  type={type}
                                  id={`default-${type}`}
                                />
                              </div>
                            ))}
                          </Form>
                        </div>

                      </div>

                      <div className=" rounded-2 p-3 mb-3" style={{ background: '#F6F4F4', borderLeft: "solid 6px #005BE7", borderRadius: "none" }}>



                        <div className="d-flex align-items-start justify-content-between flex-wrap gap-1 ">
                          <div className="d-flex flex-column gap-1">
                            <span className="">5.	Staff Allocation to Wards</span>
                            <span style={{ color: "#959292" }}>27/8/2020 | 5:00 pm</span>
                          </div>

                          <Form>
                            {['checkbox'].map((type) => (
                              <div key={`default-${type}`} className="mb-3">
                                <Form.Check // prettier-ignore
                                  type={type}
                                  id={`default-${type}`}
                                />
                              </div>
                            ))}
                          </Form>
                        </div>

                      </div>

                      <div className=" rounded-2 p-3 mb-3" style={{ background: '#F6F4F4', borderLeft: "solid 6px #005BE7", borderRadius: "none" }}>



                        <div className="d-flex align-items-start justify-content-between flex-wrap gap-1 ">
                          <div className="d-flex flex-column gap-1">
                            <span className="">6.	Resource Usage Reports</span>
                            <span style={{ color: "#959292" }}>27/8/2020 | 5:00 pm</span>
                          </div>

                          <Form>
                            {['checkbox'].map((type) => (
                              <div key={`default-${type}`} className="mb-3">
                                <Form.Check // prettier-ignore
                                  type={type}
                                  id={`default-${type}`}
                                />
                              </div>
                            ))}
                          </Form>
                        </div>

                      </div>

                    </Tab.Pane>

                    <Tab.Pane eventKey="11">
                      <div className=" rounded-2 p-3 mb-3" style={{ background: '#F6F4F4', borderLeft: "solid 6px #005BE7", borderRadius: "none" }}>



                        <div className="d-flex align-items-start justify-content-between flex-wrap gap-1 ">
                          <div className="d-flex flex-column gap-1">
                            <span className="">1.	Consent Form Templates</span>
                            <span style={{ color: "#959292" }}>27/8/2020 | 5:00 pm</span>
                          </div>

                          <Form>
                            {['checkbox'].map((type) => (
                              <div key={`default-${type}`} className="mb-3">
                                <Form.Check // prettier-ignore
                                  type={type}
                                  id={`default-${type}`}
                                />
                              </div>
                            ))}
                          </Form>
                        </div>

                      </div>

                      <div className=" rounded-2 p-3 mb-3" style={{ background: '#F6F4F4', borderLeft: "solid 6px #005BE7", borderRadius: "none" }}>



                        <div className="d-flex align-items-start justify-content-between flex-wrap gap-1 ">
                          <div className="d-flex flex-column gap-1">
                            <span className="">2.	Digital Signature Integration</span>
                            <span style={{ color: "#959292" }}>27/8/2020 | 5:00 pm</span>
                          </div>

                          <Form>
                            {['checkbox'].map((type) => (
                              <div key={`default-${type}`} className="mb-3">
                                <Form.Check // prettier-ignore
                                  type={type}
                                  id={`default-${type}`}
                                />
                              </div>
                            ))}
                          </Form>
                        </div>

                      </div>

                      <div className=" rounded-2 p-3 mb-3" style={{ background: '#F6F4F4', borderLeft: "solid 6px #005BE7", borderRadius: "none" }}>



                        <div className="d-flex align-items-start justify-content-between flex-wrap gap-1 ">
                          <div className="d-flex flex-column gap-1">
                            <span className="">3.	Customizable Consent Forms</span>
                            <span style={{ color: "#959292" }}>27/8/2020 | 5:00 pm</span>
                          </div>

                          <Form>
                            {['checkbox'].map((type) => (
                              <div key={`default-${type}`} className="mb-3">
                                <Form.Check // prettier-ignore
                                  type={type}
                                  id={`default-${type}`}
                                />
                              </div>
                            ))}
                          </Form>
                        </div>

                      </div>

                      <div className=" rounded-2 p-3 mb-3" style={{ background: '#F6F4F4', borderLeft: "solid 6px #005BE7", borderRadius: "none" }}>


                        <div className="d-flex align-items-start justify-content-between flex-wrap gap-1 ">
                          <div className="d-flex flex-column gap-1">
                            <span className="">4.	Consent History and Records</span>
                            <span style={{ color: "#959292" }}>27/8/2020 | 5:00 pm</span>
                          </div>

                          <Form>
                            {['checkbox'].map((type) => (
                              <div key={`default-${type}`} className="mb-3">
                                <Form.Check // prettier-ignore
                                  type={type}
                                  id={`default-${type}`}
                                />
                              </div>
                            ))}
                          </Form>
                        </div>

                      </div>

                      <div className=" rounded-2 p-3 mb-3" style={{ background: '#F6F4F4', borderLeft: "solid 6px #005BE7", borderRadius: "none" }}>



                        <div className="d-flex align-items-start justify-content-between flex-wrap gap-1 ">
                          <div className="d-flex flex-column gap-1">
                            <span className="">5.	Legal Compliance Management</span>
                            <span style={{ color: "#959292" }}>27/8/2020 | 5:00 pm</span>
                          </div>

                          <Form>
                            {['checkbox'].map((type) => (
                              <div key={`default-${type}`} className="mb-3">
                                <Form.Check // prettier-ignore
                                  type={type}
                                  id={`default-${type}`}
                                />
                              </div>
                            ))}
                          </Form>
                        </div>

                      </div>


                      <div className=" rounded-2 p-3 mb-3" style={{ background: '#F6F4F4', borderLeft: "solid 6px #005BE7", borderRadius: "none" }}>



                        <div className="d-flex align-items-start justify-content-between flex-wrap gap-1 ">
                          <div className="d-flex flex-column gap-1">
                            <span className="">6.	Patient Acknowledgment Alerts</span>
                            <span style={{ color: "#959292" }}>27/8/2020 | 5:00 pm</span>
                          </div>

                          <Form>
                            {['checkbox'].map((type) => (
                              <div key={`default-${type}`} className="mb-3">
                                <Form.Check // prettier-ignore
                                  type={type}
                                  id={`default-${type}`}
                                />
                              </div>
                            ))}
                          </Form>
                        </div>

                      </div>

                    </Tab.Pane>

                    <Tab.Pane eventKey="12">

                      <div className=" rounded-2 p-3 mb-3" style={{ background: '#F6F4F4', borderLeft: "solid 6px #005BE7", borderRadius: "none" }}>



                        <div className="d-flex align-items-start justify-content-between flex-wrap gap-1 ">
                          <div className="d-flex flex-column gap-1">
                            <span className="">1.	Patient Analytics</span>
                            <span style={{ color: "#959292" }}>27/8/2020 | 5:00 pm</span>
                          </div>

                          <Form>
                            {['checkbox'].map((type) => (
                              <div key={`default-${type}`} className="mb-3">
                                <Form.Check // prettier-ignore
                                  type={type}
                                  id={`default-${type}`}
                                />
                              </div>
                            ))}
                          </Form>
                        </div>

                      </div>

                      <div className=" rounded-2 p-3 mb-3" style={{ background: '#F6F4F4', borderLeft: "solid 6px #005BE7", borderRadius: "none" }}>



                        <div className="d-flex align-items-start justify-content-between flex-wrap gap-1 ">
                          <div className="d-flex flex-column gap-1">
                            <span className="">2.	Doctor Performance Analytics</span>
                            <span style={{ color: "#959292" }}>27/8/2020 | 5:00 pm</span>
                          </div>

                          <Form>
                            {['checkbox'].map((type) => (
                              <div key={`default-${type}`} className="mb-3">
                                <Form.Check // prettier-ignore
                                  type={type}
                                  id={`default-${type}`}
                                />
                              </div>
                            ))}
                          </Form>
                        </div>

                      </div>

                      <div className=" rounded-2 p-3 mb-3" style={{ background: '#F6F4F4', borderLeft: "solid 6px #005BE7", borderRadius: "none" }}>



                        <div className="d-flex align-items-start justify-content-between flex-wrap gap-1 ">
                          <div className="d-flex flex-column gap-1">
                            <span className="">3.	Appointment Analytics</span>
                            <span style={{ color: "#959292" }}>27/8/2020 | 5:00 pm</span>
                          </div>

                          <Form>
                            {['checkbox'].map((type) => (
                              <div key={`default-${type}`} className="mb-3">
                                <Form.Check // prettier-ignore
                                  type={type}
                                  id={`default-${type}`}
                                />
                              </div>
                            ))}
                          </Form>
                        </div>

                      </div>

                      <div className=" rounded-2 p-3 mb-3" style={{ background: '#F6F4F4', borderLeft: "solid 6px #005BE7", borderRadius: "none" }}>


                        <div className="d-flex align-items-start justify-content-between flex-wrap gap-1 ">
                          <div className="d-flex flex-column gap-1">
                            <span className="">4.	Financial Reports (Billing, Payments)</span>
                            <span style={{ color: "#959292" }}>27/8/2020 | 5:00 pm</span>
                          </div>

                          <Form>
                            {['checkbox'].map((type) => (
                              <div key={`default-${type}`} className="mb-3">
                                <Form.Check // prettier-ignore
                                  type={type}
                                  id={`default-${type}`}
                                />
                              </div>
                            ))}
                          </Form>
                        </div>

                      </div>

                      <div className=" rounded-2 p-3 mb-3" style={{ background: '#F6F4F4', borderLeft: "solid 6px #005BE7", borderRadius: "none" }}>



                        <div className="d-flex align-items-start justify-content-between flex-wrap gap-1 ">
                          <div className="d-flex flex-column gap-1">
                            <span className="">5.	Department Performance Reports</span>
                            <span style={{ color: "#959292" }}>27/8/2020 | 5:00 pm</span>
                          </div>

                          <Form>
                            {['checkbox'].map((type) => (
                              <div key={`default-${type}`} className="mb-3">
                                <Form.Check // prettier-ignore
                                  type={type}
                                  id={`default-${type}`}
                                />
                              </div>
                            ))}
                          </Form>
                        </div>

                      </div>

                      <div className=" rounded-2 p-3 mb-3" style={{ background: '#F6F4F4', borderLeft: "solid 6px #005BE7", borderRadius: "none" }}>



                        <div className="d-flex align-items-start justify-content-between flex-wrap gap-1 ">
                          <div className="d-flex flex-column gap-1">
                            <span className="">6.	Resource Utilization Reports</span>
                            <span style={{ color: "#959292" }}>27/8/2020 | 5:00 pm</span>
                          </div>

                          <Form>
                            {['checkbox'].map((type) => (
                              <div key={`default-${type}`} className="mb-3">
                                <Form.Check // prettier-ignore
                                  type={type}
                                  id={`default-${type}`}
                                />
                              </div>
                            ))}
                          </Form>
                        </div>

                      </div>

                    </Tab.Pane>

                    <Tab.Pane eventKey="13">
                      <div className=" rounded-2 p-3 mb-3" style={{ background: '#F6F4F4', borderLeft: "solid 6px #005BE7", borderRadius: "none" }}>



                        <div className="d-flex align-items-start justify-content-between flex-wrap gap-1 ">
                          <div className="d-flex flex-column gap-1">
                            <span className="">1.	System Notifications for Admins</span>
                            <span style={{ color: "#959292" }}>27/8/2020 | 5:00 pm</span>
                          </div>

                          <Form>
                            {['checkbox'].map((type) => (
                              <div key={`default-${type}`} className="mb-3">
                                <Form.Check // prettier-ignore
                                  type={type}
                                  id={`default-${type}`}
                                />
                              </div>
                            ))}
                          </Form>
                        </div>

                      </div>

                      <div className=" rounded-2 p-3 mb-3" style={{ background: '#F6F4F4', borderLeft: "solid 6px #005BE7", borderRadius: "none" }}>



                        <div className="d-flex align-items-start justify-content-between flex-wrap gap-1 ">
                          <div className="d-flex flex-column gap-1">
                            <span className="">2.	Appointment Alerts for Patients and Doctors</span>
                            <span style={{ color: "#959292" }}>27/8/2020 | 5:00 pm</span>
                          </div>

                          <Form>
                            {['checkbox'].map((type) => (
                              <div key={`default-${type}`} className="mb-3">
                                <Form.Check // prettier-ignore
                                  type={type}
                                  id={`default-${type}`}
                                />
                              </div>
                            ))}
                          </Form>
                        </div>

                      </div>

                      <div className=" rounded-2 p-3 mb-3" style={{ background: '#F6F4F4', borderLeft: "solid 6px #005BE7", borderRadius: "none" }}>



                        <div className="d-flex align-items-start justify-content-between flex-wrap gap-1 ">
                          <div className="d-flex flex-column gap-1">
                            <span className="">3.	Payment and Billing Reminders</span>
                            <span style={{ color: "#959292" }}>27/8/2020 | 5:00 pm</span>
                          </div>

                          <Form>
                            {['checkbox'].map((type) => (
                              <div key={`default-${type}`} className="mb-3">
                                <Form.Check // prettier-ignore
                                  type={type}
                                  id={`default-${type}`}
                                />
                              </div>
                            ))}
                          </Form>
                        </div>

                      </div>

                      <div className=" rounded-2 p-3 mb-3" style={{ background: '#F6F4F4', borderLeft: "solid 6px #005BE7", borderRadius: "none" }}>


                        <div className="d-flex align-items-start justify-content-between flex-wrap gap-1 ">
                          <div className="d-flex flex-column gap-1">
                            <span className="">4.	Module Upgrade Requests Alerts</span>
                            <span style={{ color: "#959292" }}>27/8/2020 | 5:00 pm</span>
                          </div>

                          <Form>
                            {['checkbox'].map((type) => (
                              <div key={`default-${type}`} className="mb-3">
                                <Form.Check // prettier-ignore
                                  type={type}
                                  id={`default-${type}`}
                                />
                              </div>
                            ))}
                          </Form>
                        </div>

                      </div>

                      <div className=" rounded-2 p-3 mb-3" style={{ background: '#F6F4F4', borderLeft: "solid 6px #005BE7", borderRadius: "none" }}>



                        <div className="d-flex align-items-start justify-content-between flex-wrap gap-1 ">
                          <div className="d-flex flex-column gap-1">
                            <span className="">5.	Lab Report Completion Alerts</span>
                            <span style={{ color: "#959292" }}>27/8/2020 | 5:00 pm</span>
                          </div>

                          <Form>
                            {['checkbox'].map((type) => (
                              <div key={`default-${type}`} className="mb-3">
                                <Form.Check // prettier-ignore
                                  type={type}
                                  id={`default-${type}`}
                                />
                              </div>
                            ))}
                          </Form>
                        </div>

                      </div>


                      <div className=" rounded-2 p-3 mb-3" style={{ background: '#F6F4F4', borderLeft: "solid 6px #005BE7", borderRadius: "none" }}>



                        <div className="d-flex align-items-start justify-content-between flex-wrap gap-1 ">
                          <div className="d-flex flex-column gap-1">
                            <span className="">6.	Emergency Resource Alerts</span>
                            <span style={{ color: "#959292" }}>27/8/2020 | 5:00 pm</span>
                          </div>

                          <Form>
                            {['checkbox'].map((type) => (
                              <div key={`default-${type}`} className="mb-3">
                                <Form.Check // prettier-ignore
                                  type={type}
                                  id={`default-${type}`}
                                />
                              </div>
                            ))}
                          </Form>
                        </div>

                      </div>

                    </Tab.Pane>

                    <Tab.Pane eventKey="14">

                      <div className=" rounded-2 p-3 mb-3" style={{ background: '#F6F4F4', borderLeft: "solid 6px #005BE7", borderRadius: "none" }}>



                        <div className="d-flex align-items-start justify-content-between flex-wrap gap-1 ">
                          <div className="d-flex flex-column gap-1">
                            <span className="">1.	Create and Manage Clinic Admin Accounts</span>
                            <span style={{ color: "#959292" }}>27/8/2020 | 5:00 pm</span>
                          </div>

                          <Form>
                            {['checkbox'].map((type) => (
                              <div key={`default-${type}`} className="mb-3">
                                <Form.Check // prettier-ignore
                                  type={type}
                                  id={`default-${type}`}
                                />
                              </div>
                            ))}
                          </Form>
                        </div>

                      </div>

                      <div className=" rounded-2 p-3 mb-3" style={{ background: '#F6F4F4', borderLeft: "solid 6px #005BE7", borderRadius: "none" }}>



                        <div className="d-flex align-items-start justify-content-between flex-wrap gap-1 ">
                          <div className="d-flex flex-column gap-1">
                            <span className="">2.	Assign Roles and Permissions</span>
                            <span style={{ color: "#959292" }}>27/8/2020 | 5:00 pm</span>
                          </div>

                          <Form>
                            {['checkbox'].map((type) => (
                              <div key={`default-${type}`} className="mb-3">
                                <Form.Check // prettier-ignore
                                  type={type}
                                  id={`default-${type}`}
                                />
                              </div>
                            ))}
                          </Form>
                        </div>

                      </div>

                      <div className=" rounded-2 p-3 mb-3" style={{ background: '#F6F4F4', borderLeft: "solid 6px #005BE7", borderRadius: "none" }}>



                        <div className="d-flex align-items-start justify-content-between flex-wrap gap-1 ">
                          <div className="d-flex flex-column gap-1">
                            <span className="">3.	User Activity Logs</span>
                            <span style={{ color: "#959292" }}>27/8/2020 | 5:00 pm</span>
                          </div>

                          <Form>
                            {['checkbox'].map((type) => (
                              <div key={`default-${type}`} className="mb-3">
                                <Form.Check // prettier-ignore
                                  type={type}
                                  id={`default-${type}`}
                                />
                              </div>
                            ))}
                          </Form>
                        </div>

                      </div>

                      <div className=" rounded-2 p-3 mb-3" style={{ background: '#F6F4F4', borderLeft: "solid 6px #005BE7", borderRadius: "none" }}>


                        <div className="d-flex align-items-start justify-content-between flex-wrap gap-1 ">
                          <div className="d-flex flex-column gap-1">
                            <span className="">4.	Password Management and Security</span>
                            <span style={{ color: "#959292" }}>27/8/2020 | 5:00 pm</span>
                          </div>

                          <Form>
                            {['checkbox'].map((type) => (
                              <div key={`default-${type}`} className="mb-3">
                                <Form.Check // prettier-ignore
                                  type={type}
                                  id={`default-${type}`}
                                />
                              </div>
                            ))}
                          </Form>
                        </div>

                      </div>

                      <div className=" rounded-2 p-3 mb-3" style={{ background: '#F6F4F4', borderLeft: "solid 6px #005BE7", borderRadius: "none" }}>



                        <div className="d-flex align-items-start justify-content-between flex-wrap gap-1 ">
                          <div className="d-flex flex-column gap-1">
                            <span className="">5.	Account Deactivation and Reactivation</span>
                            <span style={{ color: "#959292" }}>27/8/2020 | 5:00 pm</span>
                          </div>

                          <Form>
                            {['checkbox'].map((type) => (
                              <div key={`default-${type}`} className="mb-3">
                                <Form.Check // prettier-ignore
                                  type={type}
                                  id={`default-${type}`}
                                />
                              </div>
                            ))}
                          </Form>
                        </div>

                      </div>


                      <div className=" rounded-2 p-3 mb-3" style={{ background: '#F6F4F4', borderLeft: "solid 6px #005BE7", borderRadius: "none" }}>



                        <div className="d-flex align-items-start justify-content-between flex-wrap gap-1 ">
                          <div className="d-flex flex-column gap-1">
                            <span className="">6.	Multi-Factor Authentication Management</span>
                            <span style={{ color: "#959292" }}>27/8/2020 | 5:00 pm</span>
                          </div>

                          <Form>
                            {['checkbox'].map((type) => (
                              <div key={`default-${type}`} className="mb-3">
                                <Form.Check // prettier-ignore
                                  type={type}
                                  id={`default-${type}`}
                                />
                              </div>
                            ))}
                          </Form>
                        </div>

                      </div>
                    </Tab.Pane>
                  </Tab.Content>


                </Col>
              </Row>
            </Tab.Container>
          </div>
        </div>


      </main>

    </>
  );
}

export default Modules;
